import axios from './axiosInstance';
import { APITag } from '../../types';

interface SportAreaParams {
  sport: string;
  areaId: string;
}

interface CreateTagParams extends SportAreaParams {
  name: string;
}

const getTags = ({ sport, areaId }: SportAreaParams): Promise<APITag[]> => {
  const url = `/${sport}/areas/${areaId}/tags`;
  return axios.get(url)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const createTag = ({ sport, areaId, name }: CreateTagParams): Promise<APITag> => {
  const url = `/${sport}/areas/${areaId}/tags`;
  return axios.put(url, { name })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const tagFunctions = {
  getTags,
  createTag,
};

export default tagFunctions;
